var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFootIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.1778 5.83008L0.800049 11.4606V19.795C0.800049 21.2212 2.95415 21.9343 4.2169 20.9241L13.8361 13.2285C15.3774 11.9954 15.3774 9.98984 13.8361 8.75676L10.1778 5.83008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800049 2.20688V11.4623L10.1778 5.83181L4.2169 1.06295C2.95415 0.0675762 0.800049 0.780678 0.800049 2.20688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFootIcon03);
export default __webpack_public_path__ + "static/media/chat-foot-icon-03.50cd7117bf98c6fa86dc6df20712ce2a.svg";
export { ForwardRef as ReactComponent };